import React from 'react'
import { ACTIONS } from '@/store/Documentation'
import { Button } from '@/components/button'
import Icon from '@/components/Icon'
import HiddenButtons from '@/components/hiddenButtons'
import { ITEM_TYPES } from '@/constants'

class RowItem extends React.Component {
  getTitle = (language) => (this.props.title || {})[language]
  getLanguageCss = (language) => `lang-${language}`
  invokeAction (actionName, additionalParam) {
    const item = {
      id: this.props.id,
      title: this.props.title,
      treeType: this.props.treeType,
      itemType: (this.props.type === 'chapter' ? ITEM_TYPES.CHAPTER : ITEM_TYPES.DOCUMENT),
      file: this.props.file
    }
    if (this.props.actions && this.props.actions[actionName]) {
      this.props.actions[actionName]({ item, localize: this.props.localize })
    }
  }
  handleTitleClick ({ language }) {
    this.invokeAction(ACTIONS.EDIT, { initialTitle: this.getTitle(language), language, localize: this.props.localize })
  }
  renderTitle (lang) {
    return (<div className='rst__lang-row'>
      <div className={`row-title ${this.getLanguageCss(lang)}`} >{this.getTitle(lang)}</div>
    </div>)
  }
  render () {
    const { locale, id } = this.props
    return (
      <React.Fragment>
        <div>
          {this.props.type === 'chapter' ? (<i className='bx bx-folder' />) : (<i className='bx bx-file-blank' />)}
          {this.renderTitle('en')}
          {this.renderTitle('ar')}
        </div>
        <HiddenButtons id={id}>
          <Button
            title='Common.Edit'
            onClick={() => this.handleTitleClick({ language: locale })}><Icon name='pencil' /></Button>
          <Button
            confirmTitle='Common.Confirmation'
            confirmText='Common.AreYouSure'
            onClick={() => this.invokeAction(ACTIONS.DELETE)}><Icon name='x' /></Button>
        </HiddenButtons>
      </React.Fragment>
    )
  }
}

export default RowItem



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/documentation/dataSource/item.js